function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import './journal-selection.scss';
import React, { useEffect, useState } from 'react';
import { Controls, validators } from 'shared/helper/form';
import { T } from 'shared/helper/translate';
import JournalPreview from './JournalPreview';
import RequireServiceDetails from './RequireServiceDetailsContainer';
var AsyncSelect = Controls.AsyncSelect,
  Errors = Controls.Errors,
  MultiFieldValidation = Controls.MultiFieldValidation;
var notEmpty = validators.notEmpty;
var JournalSelectionDropdown = function JournalSelectionDropdown(_ref) {
  var validators = _ref.validators,
    disabled = _ref.disabled,
    loadOptions = _ref.loadOptions,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(AsyncSelect, {
    allowsNewSelection: true,
    className: "form-control dropdown",
    isClearable: false,
    readOnly: disabled,
    minLength: 3,
    asyncCallback: loadOptions,
    name: "journal.name",
    onChange: onChange,
    placeholder: "Select Journal",
    noOptionsMessage: "Start typing to choose a journal",
    validators: validators
  });
};
var JournalSelection = function JournalSelection(_ref2) {
  var alwaysDisplayed = _ref2.alwaysDisplayed,
    children = _ref2.children,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    displayed = _ref2.displayed,
    fetchJournalDetails = _ref2.fetchJournalDetails,
    fetchJournals = _ref2.fetchJournals,
    methods = _ref2.methods,
    required = _ref2.required,
    serviceIdentities = _ref2.serviceIdentities,
    _ref2$styles = _ref2.styles,
    styles = _ref2$styles === void 0 ? {
      wrapper: 'mb-3 control-group',
      journalSelectionWrapper: 'col-md-6',
      journalPreview: ''
    } : _ref2$styles,
    validatesJournalSelection = _ref2.validatesJournalSelection;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    journalDetails = _useState2[0],
    setJournalDetails = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    originalJournalInformation = _useState4[0],
    setOriginalJournalInformation = _useState4[1];
  var _methods$watch = methods.watch(['journal']),
    _methods$watch2 = _slicedToArray(_methods$watch, 1),
    journal = _methods$watch2[0];
  var validateJournalChanges = function validateJournalChanges(_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      journalName = _ref4[0],
      journalUrl = _ref4[1];
    var originalJournalName = originalJournalInformation.name && originalJournalInformation.name.value;
    if (journalUrl !== originalJournalInformation.url && journalName.value === originalJournalName) {
      return false;
    }
    return true;
  };
  var clearJournal = function clearJournal() {
    setJournalDetails(null);
    methods.setValue('journal.name', '');
    methods.setValue('journal.url', '');
  };
  useEffect(function () {
    if (journal && !originalJournalInformation.name) {
      setOriginalJournalInformation(journal);
    }
  }, [journal]);
  useEffect(function () {
    return function () {
      return setOriginalJournalInformation({});
    };
  }, []);
  useEffect(function () {
    if (journal && journal.name && journal.name.value) {
      setJournalDetails({
        journal: journal,
        journalUrl: journal.url || ''
      });
    }
  }, [journal && journal.name && journal.name.value]);
  if (!required && !displayed) {
    return null;
  }
  return /*#__PURE__*/React.createElement(RequireServiceDetails, {
    serviceIdentities: serviceIdentities,
    displayWithoutServices: alwaysDisplayed
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.wrapper, " clearfix journal-selection")
  }, /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement(T, {
    source: "Journal information"
  }), required ? /*#__PURE__*/React.createElement("sup", null, "*") : null), children, /*#__PURE__*/React.createElement("p", {
    className: "target-journal-description"
  }, /*#__PURE__*/React.createElement(T, {
    source: "target-journal-description"
  })), validatesJournalSelection && /*#__PURE__*/React.createElement(MultiFieldValidation, {
    name: "journalChangeValid",
    messages: {
      journalChangeValid: 'journal-url-change-error'
    },
    validators: {
      journalChangeValid: validateJournalChanges
    },
    fields: ['journal.name', 'journal.url']
  }), /*#__PURE__*/React.createElement(Errors, {
    name: "journal.name",
    messages: {
      notEmpty: 'You have selected a service that requires you to enter journal details.'
    }
  }), /*#__PURE__*/React.createElement(Errors, {
    name: "journal.url",
    messages: {
      journalUrlValid: 'Your journal website must start with http:// or https://'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "controls"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.journalSelectionWrapper || 'col-md-6'
  }, required ? /*#__PURE__*/React.createElement(JournalSelectionDropdown, {
    disabled: disabled,
    loadOptions: fetchJournals,
    onChange: setJournalDetails,
    validators: {
      notEmpty: notEmpty
    }
  }) : /*#__PURE__*/React.createElement(JournalSelectionDropdown, {
    disabled: disabled,
    loadOptions: fetchJournals,
    onChange: setJournalDetails
  }))), journalDetails && journalDetails.journal ? /*#__PURE__*/React.createElement(JournalPreview, {
    clearJournal: clearJournal,
    disabled: disabled,
    fetchJournalDetails: fetchJournalDetails,
    journal: journalDetails.journal,
    journalUrl: journalDetails.journalUrl,
    methods: methods,
    styles: styles
  }) : null)));
};
export default JournalSelection;